import { useEffect } from 'react';

import { useNavigate } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { UnlockInvalidLink, useUnlockOnMount } from '@/features/users/unlock-account';

type Props = {
    token: string;
    onResent: (email: string | null) => void;
};

export function SignInUnlockFlow({ token, onResent }: Props) {
    const navigate = useNavigate();
    const status = useUnlockOnMount(token);

    // On success, strip the token so a refresh won't re-fire the unlock POST, then show the
    // sign-in form. Runs in an effect (not render) so it can't loop or return undefined.
    useEffect(() => {
        if (status === 'unlocked') {
            void navigate({ to: '/login', search: {}, replace: true });
        }
    }, [status, navigate]);

    if (status === 'unlocking') {
        return <LoadingPage label="Unlocking your account…" />;
    }

    if (status === 'invalid') {
        return <UnlockInvalidLink token={token} onResent={onResent} />;
    }

    return null;
}
